import React from 'react';
import Joi from 'joi';

import { Alert, Button, TextField } from '@mui/material';

interface Data {
  [key: string]: string;
}

interface FormProps {
  t?: any;
}

export enum AlertSeverity {
  Error = 'error',
  Warning = 'warning',
  Info = 'info',
  Success = 'success',
}

interface FormState {
  data: Data;
  errors: Data;
  submitted?: boolean;
  submitSuccess?: boolean;
}

class Form extends React.Component<FormProps, FormState> {
  state = { data: {}, errors: {} };

  validate = () => {
    const options = { abortEarly: false };
    // @ts-ignore
    const { error } = Joi.object(this.schema).validate(
      this.state.data,
      options
    );
    if (!error) return null;

    const errors = {};
    // @ts-ignore
    for (const item of error.details) errors[item.path[0]] = item.message;

    return errors;
  };

  validateProperty = ({ name, value }: { name: string; value: string }) => {
    const obj = { [name]: value };
    // @ts-ignore
    const schema = { [name]: this.schema[name] };
    const { error } = Joi.object(schema).validate(obj);

    return error ? error.details[0].message : null;
  };

  handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    const errors = this.validate();
    this.setState({ errors: errors || {} });
    if (errors) return;

    // @ts-ignore
    this.doSubmit();
  };

  handleChange = ({
    currentTarget: input,
  }: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { errors } = this.state;
    const errorMessage = this.validateProperty(input);
    // @ts-ignore
    if (errorMessage) errors[input.name] = errorMessage;
    // @ts-ignore
    else delete errors[input.name];

    const data = { ...this.state.data };
    // @ts-ignore
    data[input.name] = input.value;
    this.setState({ data, errors });
  };

  renderButton(label: string) {
    return (
      <Button
        type='submit'
        variant='contained'
        disabled={!!this.validate()}
        sx={{ margin: 2 }}
      >
        {label}
      </Button>
    );
  }

  renderInput(
    name: string,
    label: string,
    rows?: number,
    multiline?: boolean,
    required = true
  ) {
    const { data, errors } = this.state;

    return (
      <div>
        <TextField
          id={name}
          name={name}
          label={label}
          // @ts-ignore
          error={!!errors[name]}
          // @ts-ignore
          helperText={errors[name]}
          // @ts-ignore
          value={data[name]}
          onChange={this.handleChange}
          rows={rows}
          multiline={multiline}
          required={required}
        />
      </div>
    );
  }

  renderAlert(label: string, severity: AlertSeverity) {
    return <Alert severity={severity}>{label}</Alert>;
  }
}

export default Form;
